import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";

enum ProfileMenuItemId {
    ACCOUNT_SETTINGS = "ACCOUNT_SETTINGS",
    LOGOUT = "LOGOUT",
    PREFERENCES = "PREFERENCES"
}

export interface IProfileMenuItem {
    itemId: ProfileMenuItemId;
    label: string;
    path?: string;
    testId: string;
}

export const createProfileMenuItems = (site: SiteSlug) => {
    const preferences: IProfileMenuItem = {
        itemId: ProfileMenuItemId.PREFERENCES,
        label: NAVIGATION_LABELS.PREFERENCES.CTA,
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_PREFERENCES
    };

    const accountSettings: IProfileMenuItem = {
        itemId: ProfileMenuItemId.ACCOUNT_SETTINGS,
        label: NAVIGATION_LABELS.PROFILE_MENU.ACCOUNT_SETTINGS,
        path: kmAppLink.site.user.baseWithParams({site}),
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_SETTINGS
    };

    const logout: IProfileMenuItem = {
        itemId: ProfileMenuItemId.LOGOUT,
        label: NAVIGATION_LABELS.PROFILE_MENU.LOGOUT,
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_LOGOUT
    };

    return {
        logout,
        preferences,
        standardMenuItems: [accountSettings]
    };
};
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";

enum ProfileMenuItemId {
    ACCOUNT_SETTINGS = "ACCOUNT_SETTINGS",
    LOGOUT = "LOGOUT",
    PREFERENCES = "PREFERENCES"
}

export interface IProfileMenuItem {
    itemId: ProfileMenuItemId;
    label: string;
    path?: string;
    testId: string;
}

export const createProfileMenuItems = (site: SiteSlug) => {
    const preferences: IProfileMenuItem = {
        itemId: ProfileMenuItemId.PREFERENCES,
        label: NAVIGATION_LABELS.PREFERENCES.CTA,
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_PREFERENCES
    };

    const accountSettings: IProfileMenuItem = {
        itemId: ProfileMenuItemId.ACCOUNT_SETTINGS,
        label: NAVIGATION_LABELS.PROFILE_MENU.ACCOUNT_SETTINGS,
        path: kmAppLink.site.user.baseWithParams({site}),
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_SETTINGS
    };

    const logout: IProfileMenuItem = {
        itemId: ProfileMenuItemId.LOGOUT,
        label: NAVIGATION_LABELS.PROFILE_MENU.LOGOUT,
        testId: KM_COMMON_TEST_IDS.PROFILE_MENU_LOGOUT
    };

    return {
        logout,
        preferences,
        standardMenuItems: [accountSettings]
    };
};
